import { styled } from "@mui/material/styles";
import { Box, Typography } from '@mui/material';
import CheckCircle from "../../loginImages/check-circle.svg";
import XCircle from "../../loginImages/x-circle.svg";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const Circle = styled("img")({
});

enum StatusListItemState {
  Unchecked,
  Error,
  Valid,
}

interface StatusListItemProps {
  error: StatusListItemState;
  text: string;
  size?: number;
}

const StatusListItem = ({
  error,
  text,
  size = 20,
}: StatusListItemProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {error === StatusListItemState.Error ?
          <Circle id="errorCircle" src={XCircle} alt="errorCircle" 
          sx={{
            marginLeft: 2,
            fontSize: 6,
            mr: 1.5,
          }} /> :
          error === StatusListItemState.Valid ?
            <Circle id="checkCircle" src={CheckCircle} alt="checkCircle" 
            sx={{
              marginLeft: 2,
              fontSize: 6,
              mr: 1.5,
            }}/> :
            <FiberManualRecordIcon
              sx={{
                marginLeft: 2,
                fontSize: 6,
                mr: 1.5,
              }}
            />}
      </Box>
      <Typography variant="subtitle2" fontWeight="400">{text}</Typography>
    </Box>
  );
};

export { StatusListItem, StatusListItemState };